import { memo, useState } from 'react';
import { skinUrl } from '../skin/skin';

/** Head shown by mc-heads.net when a name has no account (never a locally generated head). */
const FALLBACK_NAME = 'MHF_Steve';

/** Size of the heads on the player cards (the compass reuses the same image URL, already cached). */
export const PEER_AVATAR_SIZE = 56;

/** URL of a player's head image as shown by <Avatar> at `size` (2x for sharp HiDPI rendering). */
export function avatarSrc(uuid: string, name: string | null | undefined, size: number): string | null {
  return skinUrl(uuid, name ?? null, Math.min(128, size * 2));
}

/** Head from mc-heads.net, always (by name; on failure the default mc-heads head). */
export const Avatar = memo(function Avatar({ uuid, name, size = 48 }: { uuid: string; name?: string | null; size?: number }) {
  const [failed, setFailed] = useState(false);
  const url = avatarSrc(uuid, failed ? FALLBACK_NAME : name, size) ?? avatarSrc(uuid, FALLBACK_NAME, size);
  return (
    <img
      className="pixel-head"
      src={url ?? undefined}
      width={size}
      height={size}
      alt=""
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      draggable={false}
      onError={() => setFailed(true)}
    />
  );
});
